module.exports = __webpack_public_path__ + "media/noeyez.72a44152.mp4";